import * as React from 'react'

import { appCtx } from './ApplicationContext'
import { Injector } from './injector'
import { SECTION } from './Section'
import { ModalService } from './services/Modal/ModalService'
import { MustKycDialog, MustSowDialog } from './ui/dialog/AccountStatusDialogs'


export const RestrictionsManager = new class {
	private restrictions: Restriction[]
	private status: string
	private modalService: ModalService

	constructor() {
		this.restrictions = []
		this.modalService = Injector.get(ModalService)
	}

	apply(userInfo: UserInfo): void {
		this.restrictions = userInfo.restrictions || []
		this.status = userInfo.status
	}

	canPlay<T extends (...args: any[]) => void>(cb: T): T {
		return this.playerIsNotRestricted('CAN_NOT_PLAY', cb)
	}

	canPurchase<T extends (...args: any[]) => void>(cb: T): T {
		return this.playerIsNotRestricted('CAN_NOT_PURCHASE', cb)
	}

	canRedeem<T extends (...args: any[]) => void>(cb: T): T {
		return this.playerIsNotRestricted('CAN_NOT_REDEEM', cb)
	}

	private playerIsNotRestricted<T extends (...args: any[]) => void>(restriction: Restriction, cb: T): T {
		return ((...args: any[]) => {
			if (this.restrictions.indexOf(restriction) < 0) {
				return cb(...args)
			}

			switch (this.status) {
			case 'MUST_KYC_NOW': {
				const ctrl = this.modalService.openDialog(this.createMustKycDialog(() => ctrl.close()), {closeOnClickAway: true})
				break
			}
			case 'MUST_SOW_NOW': {
				const ctrl = this.modalService.openDialog(this.createMustSowDialog(() => ctrl.close()), {closeOnClickAway: true})
				break
			}
			default: {
				// Nothing to do?
				break
			}
			}
		}) as T
	}

	private createMustKycDialog(close: () => void) : JSX.Element {
		return (
			<MustKycDialog
				close={close}
				openVerification={() => {
					this.modalService.closeAllModals()
					appCtx.viewManager.openProfileView(SECTION.ACCOUNT)
					close()
				}}
			/>
		)
	}
	private createMustSowDialog(close: () => void) : JSX.Element {
		return (
			<MustSowDialog
				close={close}
			/>
		)
	}
}()
